import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IDateRangeFilter } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/inner/IDateRangeFilter'
import { IsOptional } from 'class-validator'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'

export class QAQCExecuteFormModel extends FormModel {

	@IsRequired()
	samplingCode?: number

	@IsRequired()
	identification?: string

	@IsRequired()
	locationCodes?: number[]

	@IsRequired()
	dateRange?: IDateRangeFilter

	@IsRequired()
	fieldRegulationCode?: number

	@IsOptional()
	fieldCodes?: number[]

	constructor(initialData?: Partial<QAQCExecuteFormModel>) {
		super(initialData)
		Object.assign(this, initialData)
	}
}
